export default "__VITE_ASSET__BthIIYhz__"